import classNames from "classnames";
import * as React from "react";
import { ReactElement } from "react";
import * as Ons from "react-onsenui";
import { STRINGS } from "../../strings";
import { translate } from "../../translate";
import SignatureBox from "../SignatureBox/SignatureBox";

export interface TrainingCenterTestSubmitPanelProps {
  disabled: boolean;
  submitting: boolean;
  initialSignatureDataURL: string | null;
  onDisabledClick: () => void;
  onSubmit: (dataURL: string | null) => void;
}

export const TrainingCenterTestSubmitPanel = React.memo(function Question(
  props: TrainingCenterTestSubmitPanelProps
): ReactElement {
  const signatureDataURL = React.useRef<string | null>(null);

  const handleSignatureModalClick = React.useCallback((): boolean => {
    if (props.submitting) {
      return false;
    }

    if (props.disabled) {
      props.onDisabledClick.call(null);
      return false;
    } else {
      return true;
    }
  }, [props.disabled, props.onDisabledClick, props.submitting]);

  const handleSignatureEnd = React.useCallback((dataURL: string | null) => {
    signatureDataURL.current = dataURL;
  }, []);

  const handleSubmitClick = React.useCallback(() => {
    if (props.submitting) {
      return;
    }

    if (props.disabled) {
      props.onDisabledClick.call(null);
    } else {
      props.onSubmit.call(null, signatureDataURL.current);
    }
  }, [props.disabled, props.onDisabledClick, props.onSubmit, props.submitting]);

  return (
    <div className="VideoScreen__submit">
      <div>
        <h3 className="VideoScreen_SignTitle">{translate(STRINGS.SIGN_ORIENTATION_VIDEO)}</h3>

        <SignatureBox
          initialData={props.initialSignatureDataURL}
          isDisabled={props.disabled}
          onClick={handleSignatureModalClick}
          onSubmit={handleSignatureEnd}
        />
      </div>
      <div className="VideoScreen__testSubmitButtonContainer">
        <button
          className={classNames({
            VideoScreen_testSubmitButton: true,
            VideoScreen_testSubmitButtonDisabled: props.disabled,
          })}
          onClick={handleSubmitClick}
        >
          {props.submitting ? (
            <Ons.ProgressCircular className="OrientationCenterScreen_loader" indeterminate={true} />
          ) : (
            translate(STRINGS.SUBMIT)
          )}
        </button>
      </div>
    </div>
  );
});
